<template>
  <div
    class="learning-center"
    :style="{
      backgroundImage: `url(${handlerBackgroundImage(routeName)})`
    }">
    <div class="nav">
      <div class="nav-content">
        <ul>
          <li>
            <!-- <i class="iconfont icon-home"></i> -->
            百项过学习中心
          </li>
          <li @click="selectCourse" :class="{active: $route.path.indexOf('elective') !== -1}">
            <i class="iconfont icon-book"></i>选课
          </li>
          <li @click="openReport" :class="{active: $route.path.indexOf('report') !== -1}">
            <i class="iconfont icon-test"></i>报告
          </li>
          <!-- <li @click="openCourseSelection"><i class="iconfont icon-book"></i>选课中心</li> -->
          <!-- <router-link to="/user-center">
            <li>
              <i class="iconfont icon-user"></i>用户中心
            </li>
          </router-link> -->
          <li @click="logout"><i class="iconfont icon-exit"></i>退出</li>
          <!-- <li v-if="isShowAnnualButton" @click="annalsDialogVisible = true">
            <i class="iconfont icon-rocket"></i>2020宇宙年报
          </li> -->
        </ul>
      </div>
    </div>
    <!-- <van-head /> -->
    <div class="learning-center-content">
      <!-- <div class="aside">
        <van-user-panel />
      </div> -->
      <div class="main">
        <transition name="fade">
          <router-view class="router-view" />
        </transition>
        <div class="no-course" v-if="isNoCourse">
          <div>
            <img src="https://img1.wxzxzj.com/vuedf27f00ec2af8e344f3b3d0bc98b44b65.png" alt="">
          </div>
          <div class="hint">
            <p>太可惜啦，你还没有开通课程！</p>
            <p>快去找老师购买学习卡并开通课程吧！</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="annals-report"
      :showClose="false"
      :visible="annalsDialogVisible">
      <img class="close" @click="annalsDialogVisible = false" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/82d7cfcf8634ce2708f3ac5da4e33035.png" alt="">
      <img class="background" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/b42fb649aef03a9c8326eec050cff64f.png" alt="">
      <van-q-r-code class="qr-code" :text="qrCodeUrl" />
    </el-dialog>
    <!--<van-course-selection ref="courseSelection" />-->
    <!--<van-quizzes-dialog ref="quizzesDialog" />-->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
// import VanUserPanel from '@/components/UserPanel.vue';
import utils from '@/services/utils';
import api from '@/api/graphql/statistic';
import english from '@/api/graphql/englishCourse';

import {
  COURSE_LIST,
  FETCH_COURSE_LIST,
  CURRENT_COURSE,
} from '@/store/learning/types';
import accountApi from '@/api/graphql/account';
import { Dialog } from 'element-ui';
import VanQRCode from '@/components//common/QRCode.vue';

const LOOP = 60000;


export default {
  components: {
    ElDialog: Dialog,
    VanQRCode,
    // VanUserPanel,
  },
  data() {
    return {
      isNoCourse: false,
      annalsDialogVisible: false,
      routeName: '',
      timer: null,
    };
  },
  watch: {
    $route: {
      handler() {
        this.routeName = this.$route.name;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      courseList: COURSE_LIST,
    }),
    qrCodeUrl() {
      const account = utils.storage('account');
      let userId = null;

      if (account) {
        userId = account.id;
      }

      const url = `activities/2020/annals?user_id=${userId}`;

      return utils.getPassionTeacherUrl(url);
    },
    isShowAnnualButton() {
      const account = utils.storage('account');
      const { isShowAnnualButton } = account || { isShowAnnualButton: false };

      return isShowAnnualButton;
    },
  },
  created() {
    this.LoopCheckMatch();
  },
  mounted() {
    // this.smartPushAnnals();
  },
  beforeDestroy() {
    this.clearTime();
  },
  methods: {
    ...mapMutations({
      setCurrentCourse: CURRENT_COURSE,
    }),
    ...mapActions({
      fetchCourseList: FETCH_COURSE_LIST,
    }),
    logout() {
      accountApi
        .logout()
        .then(({ logout }) => {
          const { url } = logout;
          utils.logout(url);
        });
    },
    selectCourse() {
      this.$router.replace('/learning-center/elective');
    },
    openReport() {
      api.getCourseReportLabelList()
        .then(({ CourseReportLabelList }) => {
          if (!CourseReportLabelList.length) {
            utils.error('您暂未订阅课程，请先联系老师订阅课程！');
          } else {
            this.$router.push({
              path: '/learning-center/report',
            });
          }
        });
    },
    smartPushAnnals() {
      /* eslint-disable */
      const account = utils.storage('account');

      if (account && account.isPushAnnual) {
        const annalsPushDate = new Date(utils.storage(`${account.id}_anals_push_date`));
        const nowDate = new Date();

        if (annalsPushDate) {

          if ((nowDate - annalsPushDate) >= 60 * 60 * 24 * 1000) {
            this.annalsDialogVisible = true;
            utils.storage(`${account.id}_anals_push_date`, new Date());
          }

        } else {
          utils.storage(`${account.id}_anals_push_date`, new Date());
          this.annalsDialogVisible = true;
        }
      }
    },
    handlerBackgroundImage(routeName) {
      if (routeName === 'english') {
        const { type } = utils.storage('bookInfo');
        if (type === 'BDC') {
          return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/4509f0a119d7a1a417c66d977d340fcd.png'
        }
        return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/1c323022d4f99255d7664513ff4a95b7.png';
      } else if (routeName === 'courseList') {
        return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/05abd3b7feae43926b5d734bd3840834.png';
      } else if (routeName === 'report') {
        return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/05abd3b7feae43926b5d734bd3840834.png';
      } else if (routeName === 'chinese') {
        return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/1c323022d4f99255d7664513ff4a95b7.png';
      } else if (routeName === 'general') {
        return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/e7a23bf4fc9dd39371af2f150034dacf.png';
      }
      return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/4509f0a119d7a1a417c66d977d340fcd.png';
    },
    checkMatch() {
      english.checkMatch().then(({ checkMatch }) => {
        const matchId = Number(utils.cookie('match_id'));
        if (matchId !== checkMatch.id && checkMatch.id) {
          const title = `${checkMatch.teacher}老师邀请你参加单词PK赛，是否参加？`;
          const describe = '点击“我要参加”按钮，登录后可以参加比赛啦！';

          utils.cookie('match_id', checkMatch.id);
          utils.confirm(describe, title, {
            confirm: '我要参加',
            cancel: '我不参加',
          }).then(() => {
            window.location.href = checkMatch.url;
          });
        }
      });
    },
    LoopCheckMatch() {
      if (this.timer) {
        this.clearTime();
      }
      this.timer = setInterval(() => {
        this.checkMatch();
      }, LOOP);
    },
    clearTime() {
      clearInterval(this.timer);
      this.timer = null;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/breadcrumb.scss';

  .learning-center {
    height: 100%;
    background-size: cover;
    .nav {
      height: $nav-height;
      background-color: $primary;
      .nav-content {
        box-sizing: border-box;
        width: 85%;
        margin: 0 auto;
        height: 100%;
        padding: 0 12px;
        ul {
          height: 100%;
          margin: 0;
          padding: 0;
          list-style: none;
          li {
            display: inline-block;
            cursor: pointer;
            height: 100%;
            color: #fff;
            line-height: $nav-height;
            padding: 0 12px;
            a {
              color: #fff;
            }
            i {
              margin-right: 5px;
            }
            &:not(:first-child):hover,
            &.active {
              background-color: $primary-light;
            }
            &:first-child {
              margin-right: 50px;
              font-size: 18px;
              font-weight: bold;
              cursor: default;
            }
          }
        }
      }
    }
    .learning-center-content {
      min-width: $content-width;
      display: flex;
      justify-content: center;
      margin: 20px 0 10px;
      height: 90%;
      min-height: 850px;
      .aside {
        // display: none;
        width: $aside-width;
        margin-right: 25px;
        border-radius: 5px;
        background-color: #fff;
        /*overflow-y: hidden;*/
      }
      .main {
        box-sizing: border-box;
        position: relative;
        width: 85%;
        height: 100%;
        min-width: 1200px;
        padding: 0 20px 20px 20px;
        border-radius: 5px;
        background-color: #fff;
        .router-view {
          position: absolute;
          left: 20px;
          top: 0;
          bottom: 20px;
          width: calc(100% - 40px);
        }
        .no-course {
          text-align: center;
          padding-top: 100px;
          .hint {
            margin-top: 60px;
            font-size: 18px;
            color: #999;
          }
        }
      }
    }
    /deep/ .annals-report {
      .el-dialog {
        position: relative;
        width: 800px;
        background: transparent;
        box-shadow: none;
        .background {
          width: 100%;
        }
        .close {
          position: absolute;
          right: 10px;
          top: 80px;
          width: 30px;
        }
        .qr-code {
          position: absolute;
          left: 140px;
          top: 250px;
          width: 120px;
        }
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  @media screen and (max-device-height: 1079px){
    .learning-center-content {
      min-height: 660px!important;
    }
  }
</style>
